import colors from './colors'

export const borders = {
    bdrltbl: `1px solid ${colors['ltblue1-5']}`,
    greye9: `1px solid ${colors.greye9}`,
    greyd: `1px solid ${colors.greyd}`,
    green2: `1px solid ${colors.greenlt2}`,
    red2: `1px solid ${colors.redlt2}`,
}
